function t(t){let e=0;for(let r=0,n=t.length;r<n;r++)e=(e<<5)-e+t.charCodeAt(r),e|=0;return e}export{t as hashCode};
